import React from "react";

export const NonCompleted = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 13H16.3875"
      stroke="#0D0C1C"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 16.6849H16.3875"
      stroke="#0D0C1C"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8552 15C18.8552 13.6433 19.8085 12.5433 20.9844 12.5433V8.24399H5.01562V12.5433C6.19146 12.5433 7.14479 13.6433 7.14479 15C7.14479 16.3567 6.19146 17.4567 5.01562 17.4567V21.756H20.9844V17.4567C19.8085 17.4567 18.8552 16.3567 18.8552 15Z"
      stroke="#0D0C1C"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 28C27.3137 28 30 25.3137 30 22C30 18.6863 27.3137 16 24 16C20.6863 16 18 18.6863 18 22C18 22.7229 18.1279 23.416 18.3622 24.0578C19.2019 26.3579 21.4092 28 24 28Z"
      fill="#646567"
      stroke="#646567"
      strokeWidth="1.09091"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.0029 25.5006C24.1533 25.5008 24.2754 25.6235 24.2754 25.774C24.2752 25.9243 24.1532 26.0462 24.0029 26.0465C23.8525 26.0465 23.7297 25.9244 23.7295 25.774C23.7295 25.6234 23.8523 25.5006 24.0029 25.5006Z"
      fill="#646567"
      stroke="white"
      strokeWidth="0.545455"
    />
    <path
      d="M22.8281 19.5334C23.9081 19.0562 25.3056 19.1129 25.7829 19.8853C26.2601 20.6576 25.9307 21.556 25.1125 22.2493C24.2943 22.9425 23.9992 23.3189 23.9992 23.8644"
      stroke="white"
      strokeWidth="1.09091"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
